// Imports
import { PortalContext } from 'src/modules/01 Global/jsx/contexts.jsx';
import { EmailLink } from 'src/modules/unread-emails/jsx/component.jsx';


// Stateless components

export function PortalHeader(props) {

    //
    // Sub components
    //

    function toggleMenu(e){
        var target = e.currentTarget;
        var nav_panel = document.querySelector('.nav-panel');

        var search_toggle = document.querySelector('.header__search-toggle');

        if (target.classList.contains('active')) {
            target.classList.remove('active');
            nav_panel.classList.remove('active');
        } else {
            // remove active search bar if open
            search_toggle.classList.remove('active');

            target.classList.add('active');
            nav_panel.classList.add('active');
        }
    };

    function toggleSearch(e){
        var target = e.currentTarget;
        var nav_panel = document.querySelector('.nav-panel');
        var nav_panel_toggle = document.querySelector('.header__mobile-toggle');
    
        if (target.classList.contains('active')) {
            target.classList.remove('active');
        } else {
            // remove active nav panel if open
            if(nav_panel && nav_panel_toggle){
                nav_panel.classList.remove('active');
                nav_panel_toggle.classList.remove('active');
            }
            
            target.classList.add('active');
        }
    };

    function MobileMenuToggleIcon(props) {
        var icons = props['icons'];
        var open_menu_icon = {
            '__html': icons['menu_open']
        };
        var close_menu_icon = {
            '__html': icons['menu_close']
        };

        return (
            <button className="header__mobile-toggle" onClick={toggleMenu}>
                <span className="visuallyhidden">Toggle mobile menu</span>
                <span dangerouslySetInnerHTML={open_menu_icon}></span>
                <span dangerouslySetInnerHTML={close_menu_icon}></span>
            </button>
        );
    }

    function Logo(props) {
        var logo = props['logo'];
        var logo_url = logo['url'];
        var portal_url = logo['portal_url'];
        var logo_image = logo['image'];
        var logo_alt = logo['alt'];

        return (
            <div className="header-logo__wrapper">
                <a href={logo_url} className="header-logo">
                    <img className="header-logo__img" src={logo_image} alt={logo_alt} />
                </a>
                <a href={portal_url} className="header__title">
                    myGriffith
                </a>
            </div>
        );
    }
    
    function StudentLinks(props) {
        var links = props['links'];

        var links_list = links.map(function(link){
            var link_name = link['name'];
            var link_elem = link_name;

            if(link_name === 'Email') {
                link_elem = <EmailLink />;
            }

            return (
                <li className="header-nav__item" key={link['id']}>
                    <a href={link['url']} className="header-nav__link">{link_elem}</a>
                </li>
            );
        });

        return  <ul className="header-nav">{links_list}</ul>
    }

    function PortalSearch(props) {
        var search = props['search'];
        var search_open_icon = {
            '__html': search['icons']['search_open']
        };
        var search_close_icon = {
            '__html': search['icons']['search_close']
        };
        var search_submit_icon = {
            '__html': search['icons']['search_submit']
        };

        return (
            <>
            <div className="header__search">
                <button className="header__search-toggle" onClick={toggleSearch}>
                    <span className="visuallyhidden">Toggle search bar</span>
                    <span dangerouslySetInnerHTML={search_open_icon}></span>
                    <span dangerouslySetInnerHTML={search_close_icon}></span>
                </button>
                <div className="search-bar__wrapper">
                    <form action={search['action']} className="search-bar__form" target="_blank">
                        <label htmlFor="search-bar__query" className="visuallyhidden">Search website</label>
                        <input type="text" name="query" id="search-bar__query" title="Search website" placeholder="What can we help you find?" className="search-bar__query" autoComplete="off" />
                        <input type="hidden" name="collection" value={search['collection']} />
                        <input type="submit" id="search-bar__submit" aria-label="Search" className="search-bar__submit-input visuallyhidden" />
                        <label htmlFor="search-bar__submit" className="search-bar__submit-label">
                            <span dangerouslySetInnerHTML={search_submit_icon}></span>
                        </label>
                    </form>
                </div>
            </div>
            </>
        );
    }

    function RenderHeader(context){
        var has_config_loaded = context['configuration'];
        var viewport = context['viewport'];

        if(has_config_loaded != null){
            var icons = context['configuration']['portal_header']['icons'];
            var logo = context['configuration']['portal_header']['logo'];
            var links = context['configuration']['portal_header']['links'];
            var search = context['configuration']['portal_header']['search'];
            search['icons'] = {
                "search_open": icons['search_open'],
                "search_close": icons['search_close'],
                "search_submit": icons['search_submit']
            };

            return (
                <>
                    {viewport < 3 && 
                        <MobileMenuToggleIcon icons={icons} />
                    }
                    <Logo logo={logo} />
                    <StudentLinks links={links} />
                    <PortalSearch search={search} />
                </>
            );
        }

        return null;
    }


    //
    // Render
    //

    return (
        <div className="header" data-ga-label="Header - Portal">
            <PortalContext.Consumer>
                {RenderHeader}
            </PortalContext.Consumer>
        </div>
    );

};
